import { createContext } from 'react';
var SWRConfigContext = createContext({});
SWRConfigContext.displayName = 'SWRConfigContext';
export default SWRConfigContext;



//////////////////
// WEBPACK FOOTER
// ./node_modules/swr/esm/swr-config-context.js
// module id = 22
// module chunks = 0 1 2 3